import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/flag-off.vue
var s = {
	name: "DtIconFlagOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--flag-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Flag Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M3.5 1A.5.5 0 0 1 4 .5c.847 0 1.548.28 2.158.525l.028.01C6.82 1.29 7.36 1.5 8 1.5c.694 0 1.13-.115 1.377-.214a1.341 1.341 0 0 0 .28-.15.5.5 0 0 1 .843.364V7a.5.5 0 0 1-1 0V2.302c-.364.112-.854.198-1.5.198-.847 0-1.548-.28-2.158-.525l-.028-.01C5.18 1.71 4.64 1.5 4 1.5a.5.5 0 0 1-.5-.5ZM1.354.646a.5.5 0 1 0-.708.708l.854.853V11a.5.5 0 0 0 1 0V7.769c.035-.017.076-.036.123-.055C2.87 7.615 3.306 7.5 4 7.5c.64 0 1.18.21 1.814.464l.028.011c.558.224 1.193.477 1.945.52l2.86 2.859a.5.5 0 0 0 .707-.708l-10-10ZM4 6.5c.847 0 1.548.28 2.158.525l.028.01.237.095L2.5 3.207v3.491c.364-.112.854-.198 1.5-.198Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=flag-off.js.map